import { useEffect } from "react";

interface StructuredDataProps {
  id: string;
  data: Record<string, unknown> | Array<Record<string, unknown>>;
}

const StructuredData = ({ id, data }: StructuredDataProps) => {
  useEffect(() => {
    const scriptId = `structured-data-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(data);

    return () => {
      script?.remove();
    };
  }, [id, data]);

  return null;
};

export default StructuredData;
